<template>
  <div v-if="userProfile" class="goro-user-avatar-component">
    <b-dropdown ref="dropdown" variant="link" toggle-class="text-decoration-none" no-caret
                class="sub-menu-al-right goro-dropdown-site-menu-custom goro-dropdown-user-avatar"
                @hidden="openSubmenu = null">
      <template #button-content>
        <div class="content d-flex flex-row align-items-center" @click="showDropdown">
          <img v-if="avatarUrl" class="img-avatar mt-1" :src="avatarUrl" width="36" />
          <default-avatar v-else :width="36" :height="36"></default-avatar>
          <div class="ml-2 d-flex flex-column align-items-start justify-content-center">
            <p class="font-16 font-weight-bold main-color">{{ myProfileText }}</p>
            <p class="text-uuid">{{ $t('GORO_ID') }}: {{ uuid }}</p>
          </div>
        </div>
      </template>
      <b-dropdown-item v-if="!this.isInAdminPage && !isPartnerRole && !isRoleAdmin" class="sub-item" @click="basicInfo">
        <img :src="icons.profile" class="sub-item-icon" alt="">
        {{ $t('account.PROFILE') }}
      </b-dropdown-item>

      <b-dropdown-item v-if="!this.isInAdminPage && !isPartnerRole && !isRoleAdmin" class="sub-item"
                       @click="navigate('withdrawalHistory')">
        <img :src="icons.withdrawal" class="sub-item-icon" alt="">
        {{ $t('WITHDRAWALS.WITHDRAWALS') }}
      </b-dropdown-item>

      <li v-if="!this.isInAdminPage && !isPartnerRole && !isRoleAdmin" class="sub-item dropdown-item-submenu"
          :class="{ open: openSubmenu === 'security' }">
        <a class="dropdown-item" href="#" @click.prevent.stop="toggleSubmenu('security')">
          <span class="submenu-label">
            <img :src="icons.security" class="sub-item-icon" alt="">
            {{ $t('ACCOUNT_SECURITY.TITLE') }}
          </span>
          <img :src="icons.arrowRight" class="submenu-arrow" alt="">
        </a>
        <ul class="dropdown-submenu">
          <li class="sub-item">
            <a class="dropdown-item" href="#" @click.prevent="navigate('password')">
              <img :src="icons.password" class="sub-item-icon" alt="">
              {{ $t('ACCOUNT_SECURITY.PASSWORD.TITLE') }}
            </a>
          </li>
          <li class="sub-item">
            <a class="dropdown-item" href="#" @click.prevent="navigate('pin')">
              <img :src="icons.changePin" class="sub-item-icon" alt="">
              {{ $t('PIN_SECURITY.CHANGE_PIN') }}
            </a>
          </li>
          <li class="sub-item">
            <a class="dropdown-item" href="#" @click.prevent="navigate('twoFactorAuth')">
              <img :src="icons.twoFactorAuth" class="sub-item-icon" alt="">
              {{ $t('TWO_FA.TWO_FACTOR_AUTHENTICATION') }}
            </a>
          </li>
        </ul>
      </li>

      <b-dropdown-divider v-if="!isRoleAdmin"></b-dropdown-divider>
      <b-dropdown-item class="sub-item" @click="logout">
        <img :src="icons.logout" class="sub-item-icon" alt="">
        {{ $t('account.LOGOUT') }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>

import { urlImage } from "@/helpers/common"
import roles, { isAdmin, isPartner, isUser } from "../constants/roles"
import DefaultAvatar from "../components/DefaultAvatar.vue"

export default {
  components: {
    DefaultAvatar,
  },

  emits: ['close-menu'],

  data() {
    return {
      openSubmenu: null,
      icons: {
        profile: require('@/assets/img/menu/profile.svg'),
        logout: require('@/assets/img/menu/logout.svg'),
        arrowRight: require('@/assets/img/menu/arrow-right.svg'),
        withdrawal: require('@/assets/img/menu/withdrawal.svg'),
        security: require('@/assets/img/menu/security.svg'),
        password: require('@/assets/img/menu/password.svg'),
        changePin: require('@/assets/img/menu/change-pin.svg'),
        twoFactorAuth: require('@/assets/img/menu/2fa.svg'),
      },
    }
  },

  methods: {
    showDropdown() {
      if (this.$refs && this.$refs.dropdown) {
        this.$refs.dropdown.show()
      }
    },
    async openMyPortfolio() {
      await this.$router.push({ name: 'assetsOverview' });
    },
    async logout() {
      const isInAdminPage = this.isInAdminPage || isAdmin();
      const isInAccountPage = this.isInAccountPage || isUser();
      const isPartnerPage = isPartner()

      await store.dispatch('doLogout');
      if (isInAdminPage) {
        await this.$router.push({ name: 'loginAdmin' });
      } else if (isPartnerPage) {
        await this.$router.push({ name: 'loginPartner' });
      } else if (isInAccountPage) {
        await this.$router.push({ name: 'login' });
      }
      this.closeMenu()
    },
    async basicInfo() {
      await this.$router.push({ name: 'myAccount' });
      this.closeMenu()
    },
    toggleSubmenu(key) {
      this.openSubmenu = this.openSubmenu === key ? null : key
    },
    async navigate(name) {
      await this.$router.push({ name });
      this.openSubmenu = null
      if (this.$refs && this.$refs.dropdown) {
        this.$refs.dropdown.hide()
      }
      this.closeMenu()
    },

    closeMenu() {
      this.$emit('close-menu')
    },
  },
  computed: {
    avatarUrl() {
      const url = this.userProfile && this.userProfile.avatar_url
      return urlImage({ image: url })
    },
    uuid() {
      return this.userProfile && this.userProfile.uuid
    },
    userProfile() {
      return this.$store.getters.userProfile;
    },

    isInAdminPage() {
      return this.$route.path && this.$route.path.includes('goroadmin');
    },

    isInAccountPage() {
      return this.$route.path && this.$route.path.includes('account');
    },

    isPartnerRole() {
      return isPartner()
    },

    isUser() {
      return this.$store.getters.userProfile.role === roles.User;
    },

    myProfileText() {
      return this.isUser ? this.$t('account.MY_ACCOUNT') : this.$t('account.MANAGE');
    },

    isRoleAdmin() {
      return isAdmin();
    },
  },
}
</script>
<style lang="scss">
.goro-dropdown-user-avatar{
  .content {
    padding: 3px;
    margin-top: -3px;

    .text-uuid {
      font-size: 12px;
      color: gray;
    }

    p {
      margin: 0;
      padding: 0;
    }
  }

  .img-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid var(--primary-color);
  }
  .dropdown-toggle{
    @media(max-width: 991px) {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }

  .dropdown-menu {
    .sub-item {
      a.dropdown-item {
        display: flex;
        align-items: center;
        font-weight: 600 !important;
        color: var(--primary-color) !important;

        .sub-item-icon {
          width: 18px;
          height: 18px;
          margin-right: 12px;
          object-fit: contain;
        }
      }

      &.dropdown-item-submenu {
        position: relative;

        // Invisible bridge so the cursor can cross the gap to the submenu
        // without it closing
        &:hover::after {
          content: "";
          position: absolute;
          top: 0;
          right: 100%;
          width: 14px;
          height: 100%;
        }

        > a.dropdown-item {
          display: block !important;
          position: relative;
          padding-right: 40px;
          white-space: nowrap;

          .submenu-label {
            display: inline-flex;
            align-items: center;
            vertical-align: middle;
          }

          .submenu-arrow {
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
            width: 10px;
            height: 10px;
            margin: 0;
            object-fit: contain;
          }
        }

        .dropdown-submenu {
          display: none;
          position: absolute;
          top: 0;
          right: calc(100% + 12px);
          min-width: 220px;
          list-style: none;
          padding: 8px 16px;
          margin: 0;
          background-color: #fff;
          border: 1px solid #CCCCCC;
          border-radius: 12px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          z-index: 1;

          // Caret pointing right toward the selected (hovered) parent menu item
          &:before {
            content: "";
            position: absolute;
            top: 14px;
            right: -12px;
            width: 0;
            height: 0;
            border-top: 12px solid transparent;
            border-bottom: 12px solid transparent;
            border-left: 12px solid #CCCCCC;
          }

          &:after {
            content: "";
            position: absolute;
            top: 14px;
            right: -10px;
            width: 0;
            height: 0;
            border-top: 12px solid transparent;
            border-bottom: 12px solid transparent;
            border-left: 12px solid #fff;
          }
        }

        // Desktop: open the side flyout on hover
        @media (min-width: 992px) {
          &:hover > .dropdown-submenu {
            display: block;
          }
        }

        // On mobile the side flyout gets cut off by the viewport and hover is
        // unreliable on touch, so render the submenu inline as a tap accordion.
        @media (max-width: 991px) {
          &:hover::after {
            content: none;
          }

          > a.dropdown-item .submenu-arrow {
            // Point the arrow down to indicate it expands
            transform: translateY(-50%) rotate(90deg);
            transition: transform 0.2s ease;
          }

          .dropdown-submenu {
            display: none;
            position: static;
            right: auto;
            min-width: 0;
            padding: 0 0 0 30px;
            border: none;
            border-radius: 0;
            box-shadow: none;

            &:before,
            &:after {
              display: none;
            }
          }

          &.open {
            > a.dropdown-item .submenu-arrow {
              transform: translateY(-50%) rotate(-90deg);
            }

            > .dropdown-submenu {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
